import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-GoToTop" */'shared-components/components/GoToTop'));
